/**
 * Unified Technology enum for the entire application.
 * This is the single source of truth for technology types.
 * Used in domain models, commands, factories, and mappers.
 */
export enum Technology {
  NGS = 'NGS',
  MICROARREGLOS = 'MICROARREGLOS',
  MLPA = 'MLPA',
  EXPANSION_TRIPLETAS = 'EXPANSION_TRIPLETAS'
}

/**
 * Type guard to check if a string is a valid Technology
 */
export function isValidTechnology(
  value: string | null | undefined
): value is Technology {
  if (!value) {
    return false;
  }
  return Object.values(Technology).includes(value as Technology);
}

/**
 * Parse a string to Technology enum, with case-insensitive matching
 * @returns Technology or null if invalid
 */
export function parseTechnology(
  value: string | null | undefined
): Technology | null {
  if (!value) {
    return null;
  }

  const upperValue = value.toUpperCase().replace('-', '_');

  switch (upperValue) {
    case 'NGS':
      return Technology.NGS;
    case 'MICROARREGLOS':
      return Technology.MICROARREGLOS;
    case 'MLPA':
      return Technology.MLPA;
    case 'EXPANSION_TRIPLETAS':
      return Technology.EXPANSION_TRIPLETAS;
    default:
      return null;
  }
}
